import Entity from 'utilities/Entity';

class Task extends Entity {}
// media() {
// 	return this.hasMany(Media);
// }

export default new Task();
